export function getChipType(text?: string, entryType?: string) {
    switch (text) {
        case 'Athletics':
        case 'Cycling':
            return 'pink'
        case 'Swimming':
        case 'Aquatics':
        case 'Gymnastics':
        case 'Judo':
            return 'purple'
        case 'Badminton':
        case 'Basketball':
        case 'Table Tennis':
        case 'Weightlifting':
        case 'Wrestling':
            return 'orange'
        case 'Beach Volleyball':
            return 'blue'
        case 'Cricket':
        case 'Hockey':
        case 'Rugby':
            return 'green'
        // AFL
        case 'Q1':
        case 'Q2':
        case 'Q3':
        case 'Q4':
            return 'afl-red'
        case 'Half-time':
        case 'Full-time':
        case 'Quarter-time':
            if (entryType === 'soccer') {
                return 'nrl-black'
            }
            return 'afl-blue'
        case 'Goal':
            if (entryType === 'soccer') {
                return 'nrl-yellow'
            }
            return 'afl-main'
        case 'Baaaallll!':
        case 'Behind':
        case 'Big Call':
        case 'Brutal Hit':
        case 'Injury':
        case 'Ouch':
        case 'Score Update':
        case 'Rumour':
        case 'Confirmed':
        case 'Reaction':
        case 'Statement':
        case 'Done deal':
        case 'Pick swap':
        case 'Trade alert':
        case 'Whispers':
        case 'Prediction':
        case 'Delisted':
        case 'Compensation':
            return 'afl-main'
        // NRL
        case 'Kickoff':
        case 'Kick-off':
        case 'Half Time':
        case 'Full Time':
        case 'First Half': // SOCCER TOO
        case 'Second Half': // SOCCER TOO
        case 'Extra Time': // SOCCER
        case 'Penalty Shootout': // SOCCER
            return 'nrl-black'
        case 'Try':
        case 'Conversion Successful':
            return 'nrl-green'
        case 'Penalty':
        case 'Video Referee':
        case "Captain's Challenge":
            return 'nrl-yellow'
        case 'No try':
        case 'Conversion Unsuccessful':
        case 'Error':
        case 'Breaking':
        case 'News Update':
        case 'Red Card':
            return 'nrl-red'
        case 'Top Moments':
        case 'Premiers':
        case 'World Cup Winners':
            return 'nrl-blue'
        case 'Big Hit':
            return 'nrl-orange'
        case 'Interchange':
        case 'Line Dropout':
        case 'Offside':
        case 'Free Kick':
        case 'Substitution':
        case 'Tackle':
        case 'Shot':
        case 'Block/Save':
            return 'nrl-grey'
        case 'Group Stage':
        case 'Round of 16':
        case 'Third Place Playoff':
        case 'Quarterfinal':
        case 'Semifinal':
        case 'Final':
            return 'soccer-maroon'
        default:
            return text
    }
}
